import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Button, Collapse } from 'reactstrap'

interface IPageSectionProps {
  actions?: React.ReactNode
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  title: React.ReactNode
  collapse?: boolean
  defaultCollapsed?: boolean
}

const PageSection: React.FC<IPageSectionProps> = (props: IPageSectionProps) => {
  const [isOpen, setIsOpen] = React.useState(true)

  const toggleIsOpen = () => {
    if (props.collapse) setIsOpen(!isOpen)
  }

  return (
    <div className={`pb-1 ${props.className}`} style={props.style}>
      <div className='d-flex justify-space-between'>
        <div className='flex-grow-1'>
          <label
            className='d-flex justify-space-between flex'
            onClick={toggleIsOpen}
          >
            <h5 className='section-title'>
              {props.title}
              {props.collapse ? (
                isOpen ? (
                  <FontAwesomeIcon icon={['fas', 'caret-down']} fixedWidth />
                ) : (
                  <FontAwesomeIcon icon={['fas', 'caret-right']} fixedWidth />
                )
              ) : (
                undefined
              )}
            </h5>
          </label>
        </div>
        <div>{props.actions}</div>
      </div>
      <Collapse
        isOpen={props.collapse ? isOpen : true}
        className='border-left border-left pl-3 ml-3 border-primary'
        style={{ boxShadow: '-8px 0px 5px -5px rgba(185, 209, 17, 0.80)' }}
      >
        {props.children}
      </Collapse>
    </div>
  )
}

export default PageSection
